import { combineReducers } from 'core/redux'
import ducks from './ducks'

export default combineReducers(ducks)
